// F9.2-X · Frente 1 — EPC-QTD UI OFF (locked).
// Decisão arquitetural (mem://architecture/ubs-eap-design-invariants):
//   Fonte única e travada de KPIs = emp_vw_indicadores_blindados.
//   A flag remota emp_motor_flags.epc_qtd_enabled deixa de ser consultada
//   pela UI; qualquer reativação exige novo PR explícito + rollback documentado.
//
// Sem fallback silencioso. Logamos o source lock no boot do hook para
// que seja inspecionável em DevTools (atende DoD F1: "source lock log presente").

const EVM_SOURCE_LOCKED = 'emp_vw_indicadores_blindados';

// Log único por sessão para evitar spam.
let _logged = false;
function logSourceLock() {
  if (_logged) return;
  _logged = true;
  // eslint-disable-next-line no-console
  console.info(`[EVM-SOURCE] ${EVM_SOURCE_LOCKED} (locked) · F9.2-X/F1`);
}

/**
 * F9.2-X · Frente 1 — Hook desativado por design.
 * Sempre retorna `enabled=false`. Não consulta backend.
 * Mantido como export para compatibilidade com callers existentes.
 */
export function useEpcQtdFlag() {
  logSourceLock();
  return {
    enabled: false as const,
    isLoading: false as const,
  };
}

/**
 * Check if a specific contract uses the EPC-QTD engine.
 * A contract uses EPC-QTD when:
 * 1. epc_qtd_enabled flag is ON
 * 2. tipo_contrato_operacional is 'preco_global' (EPC) 
 *    OR tipo_medicao is 'epc' or 'hibrido'
 */
export function isContractEpcQtd(
  epcQtdEnabled: boolean,
  tipoContratoOperacional?: string,
  tipoMedicao?: string,
): boolean {
  if (!epcQtdEnabled) return false;
  return (
    tipoContratoOperacional === 'preco_global' ||
    tipoMedicao === 'epc' ||
    tipoMedicao === 'hibrido'
  );
}
